export default __webpack_public_path__ + "static/amenagement-porche-dimensions-ebd240d75be462b0df11cfd2bf16f24c.png";